import React from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import ApiService from '../../services/ApiService';

const getLayout = assignedTo => {
  const assignee = {
    name: 'assignedTo',
    label: 'Assigned To',
    validation: {
      type: 'db',
      modelName: 'Salesperson',
      format: 'user',
    },
    control: 'dbselect',
  };

  if (assignedTo) {
    assignee.data = assignedTo;
  }

  return [assignee];
};

const ReassignQuote = ({ quoteId, assignedTo }) => {
  const handleSubmit = payload => {
    const { assignedTo } = payload;
    return ApiService.put(`/db/EQS1/${quoteId}`, { assignedTo }).then(() => {
      modal.close();
    });
  };

  return (
    <div className="reassign-quote">
      <Form layout={getLayout(assignedTo)} onCancel={() => modal.close()} submit={handleSubmit} exportFormat="object" />
    </div>
  );
};

ReassignQuote.propTypes = {
  quoteId: PropTypes.number,
  assignedTo: PropTypes.number,
};

export default ReassignQuote;
